import { render, staticRenderFns } from "./WrongAnswerCard.vue?vue&type=template&id=06a6d46e&scoped=true"
import script from "./WrongAnswerCard.vue?vue&type=script&lang=js"
export * from "./WrongAnswerCard.vue?vue&type=script&lang=js"
import style0 from "./WrongAnswerCard.vue?vue&type=style&index=0&id=06a6d46e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a6d46e",
  null
  
)

export default component.exports